import { render } from "./ImageUploader.vue?vue&type=template&id=6c4e2f2e"
import script from "./ImageUploader.vue?vue&type=script&lang=js"
export * from "./ImageUploader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__